import { SidebarProvider } from '@/components/ui/sidebar'
import { AppSidebar } from '@/components/layout/AppSidebar'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { SafetyScoreCard } from './components/SafetyScoreCard'
import { DriverScorecards } from './components/DriverScorecards'
import { SafetyEvents } from './components/SafetyEvents'
import { Users, Activity } from 'lucide-react'

export function Safety() {
  return (
    <SidebarProvider>
      <div className="flex h-screen w-full">
        <AppSidebar />
        <main className="flex-1 overflow-auto p-6">
          <div className="max-w-7xl mx-auto space-y-6">
            <div>
              <h1 className="text-3xl font-bold tracking-tight">Safety Dashboard</h1>
              <p className="text-muted-foreground">
                Monitor driver behavior and fleet safety performance
              </p>
            </div>

            {/* Always visible safety score */}
            <SafetyScoreCard />

            <Tabs defaultValue="drivers" className="space-y-6">
              <TabsList className="grid w-full max-w-md grid-cols-2">
                <TabsTrigger value="drivers" className="gap-2">
                  <Users className="h-4 w-4" />
                  Driver Scores
                </TabsTrigger>
                <TabsTrigger value="events" className="gap-2">
                  <Activity className="h-4 w-4" />
                  Safety Events
                </TabsTrigger>
              </TabsList>

              <TabsContent value="drivers" className="space-y-6">
                <DriverScorecards />
              </TabsContent>

              <TabsContent value="events" className="space-y-6">
                <SafetyEvents />
              </TabsContent>
            </Tabs>
          </div>
        </main>
      </div>
    </SidebarProvider>
  )
}
